import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import has from '@dojo/framework/core/has';
import { createBreakpointMiddleware } from '@dojo/framework/core/middleware/breakpoint';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { publish } from 'pub-sub';
import { createNlsMiddleware, lccstate, userstate } from 'lcc-state';
import { Keys } from '@holmescorp/common';
import css from '../css/footer.m.css';
function getCopyrightKey() {
    const copyrightKey = getComputedStyle(document.documentElement).getPropertyValue('--dynls-copyright') || 'copyright';
    return copyrightKey.trim();
}
const breakpoint = createBreakpointMiddleware({ mobile: 0, fullsize: 769 });
const nls = createNlsMiddleware('settings');
const factory = create({ theme, lccstate, userstate, nls, breakpoint });
export const Footer = factory(({ middleware: { theme, lccstate, userstate, nls, breakpoint } }) => {
    const quizPattern = (() => {
        const { get, path } = userstate;
        return get(path('quizPattern'));
    })();
    const { get, path } = lccstate;
    const quizpatterns = get(path('quizpatterns'));
    const options = quizpatterns ? Object.keys(quizpatterns).sort() : [];
    const themeCss = theme.classes(css);
    const { isPlaceholder, messages } = nls();
    if (isPlaceholder) {
        return v('footer', { role: 'contentinfo', key: 'footer', classes: [theme.variant(), themeCss.root] });
    }
    const copyright = messages[getCopyrightKey()];
    const disclaimer = messages['disclaimer'];
    const privacy_policy_text = messages['privacy_policy_text'];
    const privacy_policy_url = messages['privacy_policy_url'];
    const privacy_policy = messages['privacy_policy'];
    const footer_label = messages['alt_footer_label'];
    const keyDownHandler = (event) => {
        event && event.stopPropagation();
        switch (event.key) {
            case Keys.Enter:
            case Keys.Space:
            case Keys.Spacebar:
                event.preventDefault();
                publish('settings/open');
        }
    };
    const clickHandler = (event) => {
        event && event.stopPropagation();
        publish('settings/open');
    };
    const bp = breakpoint.get('header');
    const product = get(path('product'));
    const productalt = `${footer_label}`;
    const mobile = bp && bp.breakpoint === 'mobile' ? '-mobile' : '';
    const productimg = `${window.hcstatic.portal_cdn}/js/images/${product}${mobile}_footer.png`;
    const footer_img = v('img', {
        classes: [],
        ...formatAriaProperties({ label: productalt }),
        role: 'img',
        xqa: 'product',
        alt: productalt,
        src: productimg,
        onclick: (event) => {
            event && event.stopPropagation();
            publish('site/homepage');
        }
    });
    const alt_footer = v('footer', { role: 'contentinfo', key: 'footer', classes: [theme.variant(), themeCss.alt] }, [
        v('div', { classes: [themeCss.alt_img] }, [footer_img]),
        v('div', { classes: [themeCss.alt_disclaimer] }, [
            v('div', { key: 'privacyprolicy', classes: [themeCss.privacypolicy] }, [
                disclaimer
                    ? v('div', { innerHTML: privacy_policy })
                    : v('a', { href: privacy_policy_url, target: '_blank' }, [privacy_policy_text])
            ]),
            disclaimer ? v('div', { key: 'disclaimer', classes: [themeCss.disclaimer] }, [disclaimer]) : null,
            v('div', { key: 'copyright', classes: [themeCss.copyright] }, [copyright])
        ])
    ]);
    return has('use-alternate-footer')
        ? alt_footer
        : v('footer', { role: 'contentinfo', key: 'footer', classes: [theme.variant(), themeCss.root] }, [
            disclaimer ? v('div', { key: 'disclaimer', classes: [themeCss.disclaimer] }, [disclaimer]) : null,
            v('div', { key: 'copyright', classes: [themeCss.copyright] }, [copyright]),
            quizpatterns && options.length > 1 && quizPattern
                ? v('div', {
                    key: 'selector',
                    xqa: 'selected quizpattern',
                    role: 'button',
                    tabIndex: 0,
                    classes: [themeCss.selector],
                    onclick: (event) => clickHandler(event),
                    onkeydown: (event) => keyDownHandler(event)
                }, [quizpatterns[quizPattern]])
                : v('div', { key: 'selector' }),
            v('div', { key: 'privacyprolicy', classes: [themeCss.privacypolicy] }, [
                disclaimer
                    ? v('div', { innerHTML: privacy_policy })
                    : v('a', { href: privacy_policy_url, target: '_blank' }, [privacy_policy_text])
            ])
        ]);
});
export default Footer;
